<template>
	<v-layout row wrap class="list-view">
		<template v-if="showAll">
			<v-flex
				xs12 mb-3 row wrap
				v-for="cat in categories"
				:key="cat.id"
			>
				<v-layout row wrap>
					<v-flex xs12 sm7 text-xs-left mb-2>
						<category-tag :category="cat"></category-tag>
					</v-flex>
					<v-flex sm5 text-xs-right mb-2 hidden-sm-and-down>
						<input-searcher
							color-new-primary
							:placeholder="`Buscar tienda de ${cat.name}`"
							prepend-icon="search"
							v-model="searcher"
						></input-searcher>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex
						xs12 sm6 md4 class="store-container"
						v-for="store in cat.stores"
						:key="store.id"
					>
						<store-card
							:store="store"
							@visit-store="$emit('visit-store', $event)"
						></store-card>
					</v-flex>
				</v-layout>
			</v-flex>
		</template>
		<template v-else>
			<v-flex xs12 sm7 text-xs-left mb-2>
				<category-tag :category="category"></category-tag>
			</v-flex>
			<v-flex sm5 text-xs-right hidden-sm-and-down mb-2>
				<input-searcher
					color-new-primary
					:placeholder="`Buscar tienda de ${category.name}`"
					prepend-icon="search"
					v-model="searcher"
				></input-searcher>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap>
					<v-flex
						xs12 sm6 md4 class="store-container"
						v-for="store in category.stores"
						:key="store.id"
					>
						<store-card
							:store="store"
							@visit-store="$emit('visit-store', $event)"
						></store-card>
					</v-flex>
				</v-layout>
			</v-flex>
		</template>
	</v-layout>
</template>

<script>
	import categoryTag from '@/components/market-place/category-tag';
	import inputSearcher from '@/components/shared/input-searcher';
	import storeCard from '@/components/market-place/store-card';

	function data() {
		return {
			searcher: '',
		};
	}

	export default {
		name: 'list-view',
		components: {
			categoryTag,
			inputSearcher,
			storeCard,
		},
		data,
		props: {
			categories: {
				default: () => [],
				type: Array,
			},
			category: {
				default: () => {},
				type: Object,
			},
			showAll: {
				default: true,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.list-view {
		margin: 11px auto 0px;
		max-width: 1200px;
		padding: 0px 5%;

		@media (min-width: 936px) {
			margin: 50px auto 0px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/list-view.vue